// Dynamic Diesels — Collection page (PLP) behavior.
// - Product type tabs: fetch this section and swap .dd-plp (no full reload).
// - Sort dropdown: on change, update the URL and reload.
// - Mobile "Filters" button: toggle sidebar visibility.

(function () {
  'use strict';

  let abortController = null;

  function getPlp() {
    return document.querySelector('.dd-plp');
  }

  function init() {
    document.addEventListener('click', onDocumentClick);
    document.addEventListener('change', onDocumentChange);
    window.addEventListener('popstate', onPopState);
  }

  function onDocumentClick(event) {
    const tabButton = event.target.closest('[data-product-type-button]');
    if (tabButton && tabButton.closest('[data-plp-tabs]')) {
      onProductTypeTabClick(tabButton);
      return;
    }

    const filterToggle = event.target.closest('[data-plp-filter-toggle]');
    if (!filterToggle) return;

    const sidebar = document.querySelector('[data-plp-sidebar]');
    if (!sidebar) return;
    const open = sidebar.classList.toggle('is-open');
    filterToggle.classList.toggle('is-open', open);
    filterToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function onDocumentChange(event) {
    const select = event.target.closest('[data-plp-sort]');
    if (!select) return;

    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }

  function onProductTypeTabClick(button) {
    if (button.disabled || button.classList.contains('is-active')) return;

    const tabs = button.closest('[data-plp-tabs]');
    const paramName = (tabs && tabs.dataset.productTypeParam) || 'filter.p.product_type';
    const nextParams = buildTabSearchParams(paramName, button);

    renderCollection(nextParams, { push: true });
  }

  function buildTabSearchParams(paramName, button) {
    const nextParams = new URLSearchParams();

    new URL(window.location.href).searchParams.forEach((value, key) => {
      if (key !== paramName && key !== 'page') nextParams.append(key, value);
    });

    const isAll = button.hasAttribute('data-product-type-action');
    if (!isAll) {
      const values = (button.dataset.productTypeValues || '')
        .split(',')
        .map((value) => value.trim())
        .filter(Boolean);
      values.forEach((value) => nextParams.append(paramName, value));
    }

    return nextParams;
  }

  function visibleUrl(searchParams) {
    const qs = searchParams.toString();
    return window.location.pathname + (qs ? '?' + qs : '');
  }

  function renderCollection(searchParams, options) {
    const push = !options || options.push !== false;
    const plp = getPlp();
    const sectionId = plp && plp.dataset.sectionId;
    const nextHref = visibleUrl(searchParams);

    if (!plp || !sectionId) {
      window.location.assign(nextHref);
      return;
    }

    const qs = searchParams.toString();
    const fetchUrl =
      window.location.pathname +
      '?section_id=' +
      encodeURIComponent(sectionId) +
      (qs ? '&' + qs : '');

    if (abortController) abortController.abort();
    abortController = new AbortController();

    plp.classList.add('is-loading');
    plp.setAttribute('aria-busy', 'true');

    fetch(fetchUrl, { signal: abortController.signal })
      .then((response) => {
        if (!response.ok) throw new Error('Failed to load collection');
        return response.text();
      })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = doc.querySelector('.dd-plp');
        if (!next) throw new Error('Collection markup missing');

        const sidebarWasOpen = Boolean(plp.querySelector('[data-plp-sidebar]')?.classList.contains('is-open'));
        const imported = document.importNode(next, true);
        plp.replaceWith(imported);

        if (sidebarWasOpen) {
          const sidebar = document.querySelector('[data-plp-sidebar]');
          const toggle = document.querySelector('[data-plp-filter-toggle]');
          if (sidebar) sidebar.classList.add('is-open');
          if (toggle) {
            toggle.classList.add('is-open');
            toggle.setAttribute('aria-expanded', 'true');
          }
        }

        if (push) {
          history.pushState({ ddPlp: true }, '', nextHref);
        }
      })
      .catch((error) => {
        if (error && error.name === 'AbortError') return;
        window.location.assign(nextHref);
      });
  }

  function onPopState() {
    if (!getPlp()) return;
    renderCollection(new URLSearchParams(window.location.search), { push: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
